import { BaseRepository } from "@/repositories/base-repository"
import type { IProductionStatementApproval } from "@/interfaces/api/production-statement-approval.interface"

export class ProductionStatementApprovalRepository extends BaseRepository<IProductionStatementApproval> {
  protected resourcePath = "administration/production-statement-approvals"
}
